import AssetsBlock from './AssetsBlock';

export default AssetsBlock;
